(function(){

  const root = document.querySelector('[data-custom-picker]');
  const form = document.querySelector('form[action="/cart/add"]');
  const priceProperty = document.querySelector('input[name="properties[_product_option_price]"]');
  const productPrice = document.querySelector('[data-product-price]');

  if (!root || !priceProperty || !form || !productPrice) {
    console.warn('Custom Picker: No required elements found');
    return;
  }

  const variantPrices = JSON.parse(priceProperty.dataset.variantPrices || '[]');

  update();

  root.addEventListener('change', function(event) {
    const wrappingRoot = event.target.closest('[data-custom-picker-wrapping]');
    const optionRoot = event.target.closest('[data-custom-picker-options]');

    if (wrappingRoot) {
      handleChangeWrapping(event, wrappingRoot);
    } else if (optionRoot) {
      handleChangeOptionChoices(event, optionRoot);
    } else {
      return;
    }

    update();
  });

  form.addEventListener('change', update);
  form.addEventListener('submit', handleSubmitForm);

  // AnyGift側とカスタムアプリのpropertyが競合しているため
  // AnyGiftでの購入動線を進んでいる際はカスタムアプリのpropertyを全て無効化する
  // 具体的にはAnyGiftのモーダル内の要素がページ上に存在する際は
  // 商品オプションのinput全てにdisabledを付与する
  new MutationObserver(function observeAnyGiftModal() {
    const pickerRoot = document.querySelector('[data-custom-picker]');
    if (!pickerRoot) return;

    const triggerElement = document.querySelector('.anygift-e-gift-modal__one__add-cart-button-area__button');
    const inputs = Array.from(pickerRoot.querySelectorAll('input'));

    for (const el of inputs) {
      el.disabled = Boolean(triggerElement);
    }
  }).observe(document.body, { childList: true, subtree: true });

  // MARK: - functions

  // フォーム送信時 必須項目が未入力の場合はアラートを表示して送信を中止する
  function handleSubmitForm(event) {
    Array
      .from(document.querySelectorAll('[data-custom-picker-required]'))
      .some(function(target) {
        console.log(target);
        if (!target.getAttribute('form')) return false;
        if (target.value) return false;

        event.preventDefault();
        const name = target.getAttribute('name').replace('properties[', '').replace(']', '');
        alert(`「${name}」の入力は必須となります。`);
        return true;
      });
  }

  // ギフト包装選択時 
  function handleChangeWrapping (event, root) {
    // 親となるチェックボックス以外の要素がクリックされた場合は何もしない
    if (!/checkbox/.test(event.target.getAttribute('type'))) {
      event.stopPropagation();
      return;
    }

    for (const input of Array.from(root.querySelectorAll('input[type="checkbox"]'))) {
      // 排他的チェックボックスの挙動を行わせる
      if (input !== event.target) {
        input.checked = false;
      }

      // ギフト包装の詳細設定(すなわち子要素)が存在する場合、
      const optionElement = input.nextElementSibling.nextElementSibling;
      if (!optionElement) continue;

      // 親がチェックされているならば子のinputにform属性をセットして
      // カートに情報を送信できるようにする
      const formId = input.checked ? input.getAttribute('form') : '';
      Array
        .from(optionElement.querySelectorAll('input, select'))
        .forEach(function(el) {
          el.setAttribute('form', formId);
        });
    }
  }
  
  // 選択肢を持つオプションの選択時 現在選択された値をinputにセットする
  function handleChangeOptionChoices (event, root) {
    if (event.target.getAttribute('type') !== 'radio') return;
    const input = root.querySelector('input[type="checkbox"]');
    input.value = event.target.value;
  }

  // 現在選択中のオプションからオプション分の合計金額を計算する
  function calcTotalAddingPrice() {
    return Array
      .from(document.querySelectorAll('input[data-custom-picker-price]'))
      .filter(function(input) {
        return input.checked && input.value !== '';
      })
      .map(function(input) {
        return Number(input.dataset.customPickerPrice);
      })
      .reduce(function(total, price) {
        return total + price;
      }, 0);
  }

  // 現在の選択中のバリアントの価格を取得する
  function getCurrentVariantPrice() {
    const id = form.querySelector('select[name="id"]').value;
    const nextPrice = variantPrices.find(v => v.id === Number(id));
    return nextPrice ? nextPrice.price : 0;
  }

  // 金額を計算して金額プロパティ、表示金額の更新を行う
  function update() {
    const totalAddingPrice = calcTotalAddingPrice();
    const currentVariantPrice = getCurrentVariantPrice();

    const nextPrice = currentVariantPrice + totalAddingPrice;
    priceProperty.value = nextPrice / 100;

    setTimeout(() => {
      const displayPrice = theme.Currency.formatMoney(nextPrice, theme.settings.moneyFormat);
      productPrice.innerText = displayPrice;
    }, 200);
  }

  window._getCurrentFormProperties = function() {
    console.log(Array.from(new FormData(form)).map(([key, value]) => `${key}: ${value}`).join(' | '));
  }

})();
